import yup from 'utils/yup';

export const initialTimesheetFormData = {
  id: '',
  user_id: '' as any,
  job_id: '' as any,
  jobRequired: false,
  task_id: '' as any,
  start: '' as string | Date,
  end: '' as string | Date,
  breaks: [] as any,
  mileage: 0 as any,
  images: [] as any[],
  images_preview: [] as any[],
  imageIndex: 0,
  islightBoxOpen: false,
  lunch_break_duration: '' as any,
  notes: '',
  is_child_timesheet: false,
};

export const timesheetFormValidationSchema = yup.object().shape({
  user_id: yup.string().required(),
  mileage: yup.number().positive().min(0),
  job_id: yup.string().when('jobRequired', {
    is: true,
    then: yup.string().required(),
    otherwise: yup.string(),
  }),
  start: yup.string().required(),
  // end: yup.string().required(),
  breaks: yup.array().of(
    yup.object().shape({
      time_break_rule_id: yup.string().required(),
      duration: yup.number().notRequired(),
      duration_min: yup.number().notRequired(),
      duration_sec: yup.number().notRequired(),
      startTime: yup
        .string()
        .when('setTime', { is: (setTime: any) => setTime.includes('yes'), then: yup.string().required() }),
      endTime: yup
        .string()
        .when('setTime', { is: (setTime: any) => setTime.includes('yes'), then: yup.string().required() }),
    })
  ),
});
